import { useSimpleFormIteratorItem } from 'react-admin';
import { useWatch, useFormContext } from 'react-hook-form';
import {
  QuickbooksCalculatedPriceField,
  QuickbooksCalculatedPriceFieldProps,
} from '../../components/QuickbooksCalculatedPriceField';
import { useEffect } from 'react';

export const TotalPriceField = (
  props: Omit<QuickbooksCalculatedPriceFieldProps, 'price'>
) => {
  const iterator = useSimpleFormIteratorItem();
  const { setValue } = useFormContext();

  const price = useWatch({ name: `lines.${iterator.index}.price` });
  const quantity = useWatch({ name: `lines.${iterator.index}.quantity` });
  const storedTotal = useWatch({ name: `lines.${iterator.index}.total` });
  
  // Recalculate total whenever price or quantity changes
  useEffect(() => {
    const effectiveQuantity = quantity ?? 1; // Default to 1 if quantity is undefined
    if (price != null && effectiveQuantity != null) {
      const calculatedTotal = price * effectiveQuantity;
      setValue(`lines.${iterator.index}.total`, calculatedTotal);
    }
  }, [price, quantity, iterator.index, setValue]);
  
  let total = 0;
  
  // Always show the current calculated total for better UX during editing
  const effectiveQuantity = quantity ?? 1;
  if (price != null) {
    total = price * effectiveQuantity;
  } else if (storedTotal !== undefined && storedTotal !== null) {
    // Fall back to stored total if price is missing
    total = storedTotal;
  }
  
  return <QuickbooksCalculatedPriceField price={total} {...props} />;
};
